import { GroupingOptionsV2 } from '@vae/server/src/utils/arrays/types/GroupingOptions'
import { useContext } from 'react'
import { ObjectContext } from '../../../../../contexts/objectContext/ObjectContext'
import { trpc } from '../../../../../modules/trpc'

interface UseProductionDataProps {
	from: string
	to: string
	timespan: GroupingOptionsV2
	isDarkMode: boolean
}

const useProductionData = ({ from, to, timespan, isDarkMode }: UseProductionDataProps) => {
	const { id: objectId } = useContext(ObjectContext)

	const { data, isLoading } = trpc.charts.getProductionChartData.useQuery(
		{
			from,
			to,
			selectedTimespan: timespan,
			objectId,
			isDarkMode,
		},
		{
			enabled: !!from && !!to && objectId !== 0,
		}
	)

	return { data, isLoading }
}

export default useProductionData
